import { useContext } from "react";
import { PatentContext } from "../context/PatentContextProvider";
import { Link } from "react-router-dom";
export function Footer() {
  const { handleLinkClick, setPatentLicensingModal } = useContext(PatentContext);
  const handlePatentLicensingModal = () => {
    setPatentLicensingModal(true)
  }
  return (
    <div className="bg-[#222831] pt-5 text-white">
      <div className="w-[90%] mx-auto flex flex-col gap-8 md:flex-row md:gap-12">

        {/* Left section (can hold logo if needed) */}
        <div className="flex items-center justify-center md:mr-10">
          {/* Optional logo or icon can go here */}
        </div>

        {/* Links Section */}
        <div className="md:w-1/3">
          <h4 className="text-2xl sm:text-3xl text-[#c1c0b9] pb-4">Links</h4>
          <ul>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/features")} to="/features">
                Platform Features
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/about-us")} to="/about-us">
                About
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/working-model")} to="/working-model">
                Getting Started
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/press-releases")} to="/press-releases">
                Press Releases
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/trade")} to="/trade">
                Company Trade Names
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/page/sms-text-marketing")} to="/page/sms-text-marketing">
                SMS text Marketing
              </Link>
            </li>
            {/* <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={handlePatentLicensingModal}>
                Patent Infringement Reports
              </Link>
            </li> */}
             <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/infringement-reports")}
              to="/infringement-reports"
              >
                Sample Infringement Reports
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/our-blogs")} to="/our-blogs">
                Our Blogs
              </Link>
            </li>
          </ul>
        </div>
        {/* Legal Section */}
        <div className="md:w-1/3">
          <h4 className="text-2xl sm:text-3xl text-[#c1c0b9] pb-4">Legal Stuff</h4>
          <ul>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("")} to="/end-user-license-agreement">
                EULA
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("")} to="/terms-of-use">
                Terms of Use
              </Link>
            </li>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("")} to="/privacy-policy">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Support Section */}
        <div className="md:w-1/3">
          <h4 className="text-2xl sm:text-3xl text-[#c1c0b9] pb-4">Support</h4>
          <ul>
            <li className="text-lg sm:text-xl pb-4 font-bold">
              <Link onClick={() => handleLinkClick("/contact-us")} to="/contact-us">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="bg-white text-center py-5 mt-8">
        <p className="text-black text-sm sm:text-base">
          © 2025 OHanlonIP, LLC. All Rights Reserved
        </p>
      </div>
    </div>

  );
}
